import TotalResponseCard from "./totalResponseCard.container";
export default TotalResponseCard